import userApi from '@api/userApi';
import ItemList from '@components/itemList';
import UserTile from '@components/userTile';
import useAuth from '@hooks/useAuth';
import { useTranslator } from '@i18n';
import { IconUser } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/users/')({
  component: UserList,
});

function UserList() {
  const { hasClaim } = useAuth();
  const t = useTranslator();

  return (
    <ItemList
      domain="users"
      icon={<IconUser />}
      readonly={!hasClaim('users/write', 'any')}
      api={userApi}
      backButton={{ to: '/profile' }}
      title={t('users.title')}
      renderItem={(user) => <UserTile user={user} showRoles />}
      availableFilters={['orgId', 'locationId']}
    />
  );
}
